export interface SearchFormValues {
  datetime: string | null;
  amount: string;
  paymentMethod: string;
  bank: string;
}

export const EMPTY_SEARCH_VALUES: SearchFormValues = {
  datetime: null,
  amount: '',
  paymentMethod: '',
  bank: ''
};

/**
 * Lee el monto tal como el comercio lo ve en la tabla: el punto separa los
 * miles y la coma los centavos. Un campo numerico interpretaba "1.200" como
 * uno coma dos y "1.200,50" no lo tomaba en absoluto.
 */
export const parseAmount = (raw: string): number => {
  const normalized = (raw ?? '').trim().replace(/\./g, '').replace(',', '.');

  return normalized === '' ? NaN : Number(normalized);
};

export const REQUIRED_MESSAGE = 'Campo obligatorio';
export const AMOUNT_MESSAGE = 'Ingresá un monto mayor a 0';
export const NOT_FOUND_MESSAGE = 'No encontramos un pago con los datos ingresados';
export const SEARCH_ERROR_MESSAGE = 'No pudimos realizar la búsqueda.';
export const METADATA_ERROR_MESSAGE = 'No pudimos cargar las opciones';
